import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './ArtProtection.scss';

export interface Props {}

const ArtProtection: React.FC<Props> = () => {
  const { t } = useTranslation();

  const isMobile = useContext(MobileContext);

  return (
    <div className={s['root']}>
      {!isMobile && (
        <div className={s['padlock']}>
          <img
            src={Url.staticCDNLink('eclipse/package-picker/padlock.svg')}
            alt=""
          />
        </div>
      )}
      <div className={s['left-section']}>
        <div className={s['new-badge']}>
          <div className={s['label']}>
            {t('packagePicker.artProtection.newBadge')}
          </div>
        </div>
        <div className={s['header']}>
          {t('packagePicker.artProtection.header')}
        </div>

        <div className={s['body']}>{t('packagePicker.artProtection.body')}</div>
      </div>
      <div className={s['right-section']}>
        <div className={s['protection-title']}>
          {t('packagePicker.artProtection.benefits')}
        </div>
        <div className={s['benefit-title']}>
          {t('packagePicker.artProtection.withoutCore')}
        </div>
        <div className={s['benefit-description']}>
          {t('packagePicker.artProtection.withoutCore.description')}
        </div>
        <div className={s['benefit-title']}>
          {t('packagePicker.artProtection.withCore')}
        </div>
        <div className={s['benefit-description']}>
          {t('packagePicker.artProtection.withCore.description')}
        </div>
      </div>
      {!isMobile && <div className={s['frame']} />}
      <div className={s['art-description']}>
        <a href={'https://www.deviantart.com/raidesart/art/Light-851485743'}>
          {t('packagePicker.artProtection.authorCredits')}
        </a>
      </div>
    </div>
  );
};
ArtProtection.displayName = 'ArtProtection';

export default ArtProtection;
